module.exports = __webpack_public_path__ + "img/example-2.c43c14ec.png";